
import AddSquare from "../../../assets/outline/AddSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AddSquareIcon({ className, dataTestid = "AddSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AddSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
